export default function Hero() {
  return (
    <section
      id="top"
      className="relative flex min-h-[560px] w-full items-center overflow-hidden bg-gradient-to-br from-primary-50 via-background-50 to-accent-50"
    >
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-8 px-4 pt-24 pb-12 md:px-6 md:pt-28 lg:grid-cols-2">
        <div className="relative z-10 w-full">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-sm text-primary-700">
            <i className="ri-sparkling-2-fill text-primary-500"></i>
            角色介绍 · 人物关系 · 入坑指南
          </span>
          <h1 className="mt-5 font-heading text-3xl leading-tight text-foreground-950 md:text-5xl">
            泡在我家的辣妹
            <span className="mt-2 block text-primary-500">女主是谁？一次搞清！</span>
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            想搞清「泡在我家的辣妹」的女主是谁、男主是什么设定、角色之间怎么互动？
            本站为你一站整理全部角色介绍与人物关系图，看一遍就能直接入坑。
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <a
              href="#female-lead"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              看女主是谁
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="#relations"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-3 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              人物关系图
              <i className="ri-community-line"></i>
            </a>
          </div>
          <dl className="mt-8 flex flex-wrap gap-6">
            <div>
              <dt className="font-heading text-2xl text-primary-500 md:text-3xl">5+</dt>
              <dd className="mt-1 text-sm text-foreground-700">主要角色档案</dd>
            </div>
            <div>
              <dt className="font-heading text-2xl text-primary-500 md:text-3xl">6</dt>
              <dd className="mt-1 text-sm text-foreground-700">人物关系线</dd>
            </div>
            <div>
              <dt className="font-heading text-2xl text-primary-500 md:text-3xl">1</dt>
              <dd className="mt-1 text-sm text-foreground-700">张入门关系图</dd>
            </div>
          </dl>
        </div>

        <div className="relative mx-auto w-full max-w-md">
          <div className="animate-floaty relative overflow-hidden rounded-[2rem] border-4 border-background-50 shadow-soft">
            <img
              src="https://readdy.ai/api/search-image?query=two%20anime%20characters%20a%20playful%20gyaru%20girl%20with%20golden%20blonde%20hair%20and%20a%20shy%20boy%20with%20brown%20hair%2C%20sitting%20together%20in%20a%20cozy%20warm%20living%20room%2C%20playful%20banter%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20soft%20afternoon%20light%2C%20romantic%20comedy%20anime%20style%2C%20high%20detail%20illustration&width=900&height=1100&seq=gal-hero-main&orientation=portrait"
              alt="泡在我家的辣妹 女主铃音与男主遥在客厅相处的温馨画面"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/70 to-transparent p-5 pt-16">
              <p className="font-heading text-lg text-background-50">「今晚也一起打游戏呀～」</p>
              <p className="mt-1 text-sm text-background-100/80">铃音 × 遥 · 寄宿日常</p>
            </div>
          </div>

          <div className="absolute -left-3 -top-3 flex items-center gap-1.5 rounded-full bg-accent-400 px-4 py-2 text-sm text-foreground-950 shadow-soft">
            <i className="ri-heart-3-fill"></i>
            正在升温
          </div>
        </div>
      </div>
    </section>
  );
}